export default "__VITE_ASSET__CHcEzuan__"